import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import { motion } from 'framer-motion';
import { toast, ToastContainer } from 'react-toastify'; // Import toast and ToastContainer
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for styling
import "./VraScheduling.css";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import upload from "../../../../assets/images/rpHomePage/upload.gif";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";
// import { Box } from '@mui/material';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import { LocalizationProvider, DesktopDatePicker, DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import * as moment from "moment";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

import "react-toastify/dist/ReactToastify.css";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import reportAPI from 'apis/panel/reports/reports';

const VraScheduling = () => {
  const navigate= useNavigate()
  const { vraSchedulingAPI  } = getAllVraShiftAPIS();
  const [uploadProgress, setUploadProgress] = useState(0); // State to track upload progress
  const { state, dispatch } = useContext(Context);



  // const handleNavigation=()=>{
  //   navigate("/panel/rpHomePage")
  // }

  const initialStartDate = moment().startOf('month').toDate();
     
  const initialEndDate = new Date();

  const [exportObj, setExportObj] = useState({
      startDate: initialStartDate,
      endDate: initialEndDate,
      shiftType: "Morning"
  });

  const handleNavigation=()=>{
    navigate("/panel/settings")
  }
 
  const handleSchedule = async () => {

    const values = {
     
      start_date: moment(exportObj.startDate).format("YYYY-MM-DD"),
      end_date: moment(exportObj.endDate).format("YYYY-MM-DD"),
      shift_type: exportObj?.shiftType
    };
    try {
      dispatch({ type: "SET_LOADING", payload: true });
  
      // Pass the start and end dates from exportObj to the API
      const response = await vraSchedulingAPI(values);
      dispatch({ type: "SET_LOADING", payload: false });
  
      if (response?.status === 200) {
        toast.success(response?.detail)
      } else {
        // Handle failure
        toast.error("Failed to create schedule.");
      }
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.error("Error creating schedule:", err);
      toast.error("Error creating schedule.");
    }
  };
  

  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
        <img src={leftarrow} alt="Back" />
      </div>
      <Box sx={{ pt: 2, pb: 2 }} className="VraShiftsTitle">
        VRA Scheduling
      </Box>
    </div>
          <Grid container spacing={4} sx={{ mt: 2, pl:4,pr:4 }}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Box className="labelproj">
            Start Date <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="startdate"
              name="startdate"
              sx={{ width: "100%" }}
              format="dd/MM/yyyy"
              renderInput={(params) => <TextField {...params} fullWidth />}
            //   maxDate={exportObj?.endDate}
              value={exportObj?.startDate}
              onAccept={(date) => {
                setExportObj({ ...exportObj, startDate: date });
              }}
            />
          </LocalizationProvider>
        </Grid>  

        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Box className="labelproj">
            End Date <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="enddate"
              name="enddate"
              sx={{ width: "100%" }}
              format = "dd/MM/yyyy"
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={exportObj?.startDate}
              value={exportObj?.endDate}
              onAccept={(date) => {
                setExportObj({ ...exportObj, endDate: date });
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Box className="labelproj">
            Shift Type <span style={{ color: "red" }}>*</span>
          </Box>
                        <FormControl fullWidth>
                        <Select
                            labelId="status"
                            id="status"
                            defaultValue=""
                            displayEmpty
                            name="status"
                            value={exportObj?.shiftType}
                            onChange={(e)=>{
                              setExportObj({ ...exportObj, shiftType: e.target.value });
                            }}
                            inputProps={{ 'aria-label': 'Without label' }}
                            style={{ border: "2px solid #B2D4F8", color: "grey" }}
                        >
                            <MenuItem value={'Morning'}>Morning</MenuItem>
                            <MenuItem value={'Evening'}>Evening</MenuItem>
                            <MenuItem value={'Night'}>Night</MenuItem>
                        </Select>
                    </FormControl>
        </Grid>

          </Grid>

      <Grid container sx={{pr:4}}>
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>
          <Button
            className="download-btn"
            // startIcon={
            //   <DownloadForOfflineIcon
            //     style={{ fontSize: 30, verticalAlign: "middle" }}
            //   />
            // }
            onClick={handleSchedule}
            // onClick={handleExport}
          >
            Schedule
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default VraScheduling;
